import { type SerializedStyles, css } from '@emotion/react';

import { ICON_BUTTON_SIZES } from '../IconButton';

const HEADER_PADDING_X = 12;

const header = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: `20px ${HEADER_PADDING_X}px`,
    flexShrink: 0,
});

const title = css({
    fontSize: 16,
    fontWeight: 600,
    color: '#080f1a',
    lineHeight: '20px',
    letterSpacing: '-0.01em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    maxWidth: `calc(100% - ${(HEADER_PADDING_X + ICON_BUTTON_SIZES.l.iconSize) * 2}px)`,
    textAlign: 'center',
});

const closeButton = css({
    position: 'absolute',
    right: HEADER_PADDING_X,
});

const list = css({
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 12px 32px 12px',
    gap: 4,
});

const rowContent = css({
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 8px',
    fontSize: 14,
    lineHeight: '20px',
    borderRadius: 4,
    cursor: 'default',

    '&:not(:disabled)': {
        '&:hover': {
            cursor: 'pointer',
            background: '#F5F7F9',
        },

        '&:focus': {
            outline: 'none',
            boxShadow: 'inset 0 0 0 2px var(--custom-action-color)',
        },
    },
});

const label = (disabled: boolean, isMobile: boolean): SerializedStyles =>
    css({
        fontWeight: 500,
        textDecoration: disabled ? 'line-through' : 'none',
        color: disabled ? '#647491' : '#080F1A',
        textAlign: 'left',
        display: '-webkit-box',
        WebkitLineClamp: isMobile ? 1 : 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    });

const price = css({
    color: '#647491',
    alignSelf: 'flex-start',
});

export default {
    header,
    title,
    closeButton,
    list,
    rowContent,
    label,
    price,
};
